export default function install(Vue, options = {}) {
  const optionsInternal = {
    duration: 2000,
    ...options,
  };

  Vue.directive('long-press', {
    bind: function bind(el, binding) {
      const self = this;

      this.$_timeout = null;
      this._onmouseup = () => {
        clearTimeout(self.$_timeout);
      };

      this._onmousedown = function longPressMouseDown(e) {
        const context = this;
        self.$_timeout = setTimeout(() => {
          binding.value.call(context, e);
        }, optionsInternal.duration);
      };

      el.addEventListener('touchstart', this._onmousedown);
      document.addEventListener('touchend', this._onmouseup);
    },
    unbind: function unbind(el) {
      clearTimeout(this.$_timeout);
      el.removeEventListener('touchstart', this._onmousedown);
      document.removeEventListener('touchend', this._onmouseup);
    },
  });
}



// WEBPACK FOOTER //
// ./src/utils/longpress.js